module.exports = __webpack_public_path__ + "speaker.2268f253.png";